import { Constants } from "@eagerdog/constants";
import { IEventRegisterRow } from "../../../services/helper.service.js";
import { IShow } from "@eagerdog/interfaces";

export namespace ConformationJunior {
  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    // Helper function to check if an element/level is available in the show
    // UKC Conformation has two storage formats for non-licensed classes:
    // - OLD format (before Dec 2025): show_element: "Veteran" (no level)
    // - NEW format (after Dec 2025 fix): show_element: "Non-Licensed Classes", level: "Veteran"
    const isElementAvailable = (elementOrLevel: string): boolean => {
      if (!show?.show_elements) return true; // If no show provided, show all options

      // Check if this specific element/level exists in the show
      return show.show_elements.some(se =>
        // NEW format: show_element = "Non-Licensed Classes", level = "Veteran"
        (se.show_element === Constants.dog_class_element.conformation_non_licensed && se.level === elementOrLevel) ||
        // OLD format: show_element = "Veteran" (no level field)
        se.show_element === elementOrLevel ||
        se.level === elementOrLevel
      );
    };

    // Filter non-licensed options based on available show elements
    const nonLicensedOptions = [
      { value: Constants.dog_class_element_level.novice_puppy, id: Constants.dog_class_element_level.novice_puppy },
      { value: Constants.dog_class_element_level.veteran, id: Constants.dog_class_element_level.veteran },
      { value: Constants.dog_class_element_level.brood_bitch_stud_dog, id: Constants.dog_class_element_level.brood_bitch_stud_dog },
      { value: Constants.dog_class_element_level.brace, id: Constants.dog_class_element_level.brace },
      { value: Constants.dog_class_element_level.total_dog, id: Constants.dog_class_element_level.total_dog },
      { value: Constants.dog_class_element_level.total_junior, id: Constants.dog_class_element_level.total_junior }
    ].filter(option => isElementAvailable(option.value) || isElementAvailable(option.id));

    const formRows: IEventRegisterRow[] = [
      {
        allowDuplicates: false,
        inputs: [
          {
            type: "dropdown",
            flex: 2,
            id: Constants.dog_class_element.conformation,
            label: Constants.dog_class_element.conformation,
            options: [
              { value: "None", id: "None" },
              { value: Constants.dog_class_element_level.puppy, id: Constants.dog_class_element_level.puppy },
              { value: Constants.dog_class_element_level.junior, id: Constants.dog_class_element_level.junior },
              { value: Constants.dog_class_element_level.adult, id: Constants.dog_class_element_level.adult },
              { value: Constants.dog_class_element_level.open, id: Constants.dog_class_element_level.open },
              { value: Constants.dog_class_element_level.breader_handler, id: Constants.dog_class_element_level.breader_handler },
              { value: Constants.dog_class_element_level.champion, id: Constants.dog_class_element_level.champion },
              { value: Constants.dog_class_element_level.grand_champion, id: Constants.dog_class_element_level.grand_champion }
            ]
          },
          {
            type: "dropdown",
            flex: 2,
            id: Constants.dog_class_element.conformation_altered,
            label: Constants.dog_class_element.conformation_altered,
            options: [
              { value: "None", id: "None" },
              { value: Constants.dog_class_element_level.puppy, id: Constants.dog_class_element_level.puppy },
              { value: Constants.dog_class_element_level.junior, id: Constants.dog_class_element_level.junior },
              { value: Constants.dog_class_element_level.adult, id: Constants.dog_class_element_level.adult },
              { value: Constants.dog_class_element_level.open, id: Constants.dog_class_element_level.open },
              { value: Constants.dog_class_element_level.breader_handler, id: Constants.dog_class_element_level.breader_handler },
              { value: Constants.dog_class_element_level.champion, id: Constants.dog_class_element_level.champion },
              { value: Constants.dog_class_element_level.grand_champion, id: Constants.dog_class_element_level.grand_champion }
            ]
          }
        ]
      },
      {
        allowDuplicates: false,
        inputs: [
          {
            type: "dropdown",
            id: Constants.dog_class_element.junior_showmanship,
            label: Constants.dog_class_element.junior_showmanship,
            multiSelect: true,
            options: [
              { value: Constants.dog_class_element_level.pee_wee, id: Constants.dog_class_element_level.pee_wee },
              { value: Constants.dog_class_element_level.sub_junior, id: Constants.dog_class_element_level.sub_junior },
              { value: Constants.dog_class_element_level.pre_junior, id: Constants.dog_class_element_level.pre_junior },
              { value: Constants.dog_class_element_level.novice_junior, id: Constants.dog_class_element_level.novice_junior },
              { value: Constants.dog_class_element_level.open_junior, id: Constants.dog_class_element_level.open_junior },
              { value: Constants.dog_class_element_level.novice_senior, id: Constants.dog_class_element_level.novice_senior },
              { value: Constants.dog_class_element_level.open_senior, id: Constants.dog_class_element_level.open_senior }
            ]
          }
        ]
      }
    ];

    // Only add non-licensed section if there are available options
    if (nonLicensedOptions.length > 0) {
      formRows.push({
        allowDuplicates: false,
        inputs: [
          {
            type: "checkbox",
            label: Constants.dog_class_element.conformation_non_licensed,
            multiSelect: true,
            options: nonLicensedOptions
          }
        ]
      });
    }

    return formRows;
  };

  // Keep the original form for backward compatibility
  export const form: IEventRegisterRow[] = getForm();
}
